import { QueryParams } from "@/models/query-params.model";
import { CoursesRest } from "@/services/rest/courses.rest";
import { BehaviorSubject, Observable, take } from "rxjs";

export class CoursesService {
  constructor(private _courses = new CoursesRest()) {}
  private courses$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  courses: Observable<any> = this.courses$.asObservable();

  getCourses(queryParams: QueryParams): void {
    this._courses
      .getCourses(queryParams)
      .pipe(take(1))
      .subscribe((response) => {
        this.courses$.next(response);
      });
  }
}
